import React from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import messages from './messages';
import styles from './QuantityCounter.module.scss';
import { QuantityCounterProps } from './types';

const QuantityCounter = ({
  quantity,
  onQuantityDecrement,
  isDecrementButtonDisabled,
  onQuantityIncrement,
  isIncrementButtonDisabled,
  theme = 'cart',
}: QuantityCounterProps) => {
  const { formatMessage } = useIntl();

  const isCartTheme = theme === 'cart';
  const oneItemLeft = quantity === 1;
  const showMinus = !isCartTheme || !isDecrementButtonDisabled;
  const showPlus = !isCartTheme || !isIncrementButtonDisabled;

  return (
    <div
      className={classnames(styles['quantity-container'], {
        [styles['quantity-container-cart']]: isCartTheme,
      })}
      data-testid='quantity-container'
    >
      <div className={styles['btn-plus-minus-price']}>
        {showMinus && (
          <button
            aria-label={formatMessage(messages.decrementButtonMessage)}
            type='button'
            disabled={isDecrementButtonDisabled}
            className={classnames(
              isCartTheme && oneItemLeft
                ? styles['trash-icon']
                : 'icon-after--minus',
              styles[`rounded-button-${theme}`],
            )}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onQuantityDecrement();
              }
            }}
            onClick={() => {
              onQuantityDecrement();
            }}
            tabIndex={0}
            data-testid='btn-minus-quantity'
          />
        )}
      </div>
      <div
        className={styles[`quantity-counter-${theme}`]}
        data-testid='quantity-counter'
      >
        {quantity}
      </div>
      <div className={styles['btn-plus-minus-price']}>
        {showPlus && (
          <button
            aria-label={formatMessage(messages.incrementButtonMessage)}
            type='button'
            disabled={isIncrementButtonDisabled}
            className={classnames(
              'icon-after--plus',
              styles[`rounded-button-${theme}`],
            )}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onQuantityIncrement();
              }
            }}
            onClick={() => {
              onQuantityIncrement();
            }}
            tabIndex={0}
            data-testid='btn-plus-quantity'
          />
        )}
      </div>
    </div>
  );
};

export default QuantityCounter;
